import { useState, useEffect } from "react";
import StepperButton from "./stepper-button";
import StepContent from "./step-content";
import Step from "./step";
import AccountComponent from "./account-comp";
import AddressComponent from "./address-comp";
import { useTranslation } from "react-i18next";
import * as httpService from '../../services/HTTPService';
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const StepperComponent = () => {
    
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const finishOrderLbl = i18n.exists("forms.finishOrder") ? t('forms.finishOrder') : "Завърши поръчката";
    const [step, setStep] = useState(1);
    let [econtOffices, setOffices] = useState([]);
    const accountLbl = i18n.exists("forms.accountLbl") ? t('forms.accountLbl') : "Акаунт";
    const addressLbl = i18n.exists("forms.address") ? t('forms.address') : "Адрес";
    const shippingDetails = i18n.exists("forms.shippingDetails") ? t('forms.shippingDetails') : "Детайли за доставка";
    const cancelOrderLbl = i18n.exists("forms.cancelOrder") ? t('forms.cancelOrder') : "Откажи поръчка";
    const backBtnLbl = i18n.exists("forms.backBtnLbl") ? t('forms.backBtnLbl') : "Назад";
    const storage: any = localStorage.getItem('cartObject');
    const cartObj = JSON.parse(storage);
    const [addressFormData, setAddressFormData] = useState(Object);
    const [isValidForm, setIsValidForm] = useState(false);
    const user: any = localStorage.getItem('auth-user');
    const authUser = JSON.parse(user);
    const { phone, email } = authUser;
    const customerName = authUser.firstName + " " + authUser.lastName;

    const getAddressData = (data: any) => {
        setAddressFormData(data);
        if(data.address.trim() !== '' && data.city.trim() !== '' && data.postalCode.trim() !== '') {
            setIsValidForm(true);
        }
        else {
            setIsValidForm(false);
        }
    }

    const stepText = [<AccountComponent />, <AddressComponent formData={getAddressData} />];

    const handleNext = () => {
      if (step < stepText.length) {
        setStep(step + 1);
      }
      console.log(step);
    };
  
    const handlePrevious = () => {
      if (step > 1) {
        setStep(step - 1);
      }
      console.log(step);
    };

    const getEcontExpressOfices = () => {
        httpService.getEcontExpressOfices().then((res: any) => {
            if(res) {
                console.log(res);
                econtOffices = res.data.offices;
                setOffices(res.data.offices);
            }
        })
    }

    const finishOrder = () => {
        let productIdArray: any = [];
        if(cartObj.items && cartObj.items.length > 0) {
            cartObj.items.forEach((el: any) => {
                productIdArray.push(el.id);
            });
        }
        
        

        if(isValidForm) {
            let orderObj = {
                "customerName": customerName,
                "email": email,
                "phone": phone,
                "address": addressFormData.address,
                "city": addressFormData.city,
                "postalCode": addressFormData.postalCode,
                "comment": "",
                "productIds": productIdArray
            }
            //console.log(orderObj);
            httpService.finishOrder(orderObj).then((res) => {
                if(res) {   
                    //console.log(res);            
                    localStorage.removeItem('cartObject');
                    navigate('/thank-you');
                }
            }).
            catch((err) => {
                console.log(err);
                toast(t('forms.commonErrMsg'));
            })
        }
    }

    const BackButton = (props: any) => {
        if(props.step > 1) {
            return (
                <StepperButton styleClass={"btn btn-primary"} onClick={handlePrevious}>
                    {backBtnLbl}
                </StepperButton>
            )
        }
        return null;
    }

    const cancelOrder = () => {
        localStorage.removeItem('cartObject');
        navigate('/cart');
    }

    const CancelButton = () => {
        return (
            <span className="cancel-order" onClick={cancelOrder}>{cancelOrderLbl}</span>
        )
    }

    useEffect(() => {
        if(econtOffices.length === 0) {
            //getEcontExpressOfices();
        }
    }, [])

    return (
        <div className="steps bg-card">
          <div className="numbers">
            {stepText.map((_, index) => (
              <Step
                styleClass={step === index + 1 ? "active" : ""}
                key={`Step ${index + 1}`}
                index={index}
                heading={index === 0 ? accountLbl : addressLbl}
              />
            ))}
          </div>
          <div className="message">
            <StepContent>{stepText[step - 1]}</StepContent>
          </div>
          {step === stepText.length ? (
                // last step
                <div className="buttons">
                    <BackButton step={step} />
                    <div className="flex-box" style={{"alignItems": "center", "gap": "20px"}}>
                        <CancelButton />
                        <StepperButton
                            styleClass={step < stepText.length ? "active btn btn-primary" : "btn btn-primary"}
                            onClick={finishOrder}
                            >
                            {finishOrderLbl}
                        </StepperButton>
                    </div>
                </div>
            ) : (
            <div className="buttons end-buttons">
                <BackButton step={step} />
                <CancelButton />
                <StepperButton
                    styleClass={step < stepText.length ? "active btn btn-primary" : "btn btn-primary"}
                    onClick={handleNext}
                    >
                    {shippingDetails}
                </StepperButton>
            </div>
            )}
        </div>
      );
}

export default StepperComponent;